// 単体のtodo
// 基本的にはバックアップ用
export const todo = {
  namespaced: true,
  state: {
    todos: [],
    title: ''
  },
  mutations: {
    clear (state) {
      state.title = ''
      state.todos = []
    },
    setTitle (state, v) {
      state.title = v
    },
    setTodos (state, list) {
      state.todos = list
    }
  }
}
